// Captures query params at module-load time, before App.tsx's `copyHistory()`
// strips `location.search` by calling `browserHistory.push(location.pathname)`.
// Consumers (e.g. `*WillMount` middlewares) read via `stealCapturedURLParams`
// AFTER the URL has been stripped — the in-memory snapshot survives.

const captured = new URLSearchParams(window.location.search);

export function stealCapturedURLParams(key: string): string | null {
  const value = captured.get(key);
  captured.delete(key);
  return value;
}
